import * as Yup from "yup";

export function inititalValues() {
  return {
    email: "",
  };
}

export function validationSchema(t) {
  return Yup.object({
    email: Yup.string()
      .email(t("invalid_email"))
      .required(t("required_field"))
  });
}
